import { useMemo } from 'react';

import type { ThreeElements } from '@react-three/fiber';
import type { NavMesh as RecastNavMesh } from '@recast-navigation/core';
import type * as THREE from 'three';
import { NavMeshHelper as ThreeNavMeshHelper } from '../three/NavMeshHelper';

export type NavMeshHelperProps = {
  navMesh: RecastNavMesh;
  flags?: number;
  material?: THREE.Material;
} & Omit<ThreeElements['primitive'], 'object'>;

/**
 * Helper component to visualize the NavMesh.
 * It uses the NavMeshHelper from @recast-navigation/three to create a visual representation of the NavMesh.
 */
export const NavMeshHelper: React.FC<NavMeshHelperProps> = ({
  navMesh,
  flags,
  material,
  children,
  ...restProps
}) => {
  const helper = useMemo(
    () => new ThreeNavMeshHelper(navMesh, { flags, material }),
    [navMesh, flags, material],
  );

  return (
    <primitive object={helper} {...restProps}>
      {children}
    </primitive>
  );
};
